var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.arg.event.extendedProps.eventType,_vm._b({tag:"Component",on:{"show-overtime":overtime => _vm.$emit('show-overtime', overtime),"show-leave":leave => _vm.$emit('show-leave', leave)}},'Component',_vm.componentProperties,false))
}
var staticRenderFns = []

export { render, staticRenderFns }